import React from "react";

export default function EraseIcon({ width, height, ...params }) {
  const svgStyles = {
    cursor: "pointer",
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 26}
      height={height || 27}
      fill="none"
      style={svgStyles}
      viewBox="0 0 26 27"
      {...params}
    >
      <g clipPath="url(#eraseIcon)">
        <path
          fill="#3E4957"
          d="M24.682 1.56a2.474 2.474 0 0 0-3.512 0l-9.705 9.704a2.502 2.502 0 0 0-2.78-.28L.939 15.2a.705.705 0 0 0-.334.434.677.677 0 0 0 .1.541 38.118 38.118 0 0 0 4.27 5.092 38.11 38.11 0 0 0 5.091 4.27.65.65 0 0 0 .38.118h.162a.707.707 0 0 0 .433-.334l4.225-7.755a2.51 2.51 0 0 0-.289-2.772l9.705-9.678a2.474 2.474 0 0 0 0-3.557ZM14.065 16.906l-.722 1.327-5.335-5.336 1.327-.722c.105-.055.217-.095.334-.117a1.28 1.28 0 0 1 .713.1c.107.052.204.122.289.207l3.232 3.205c.084.084.154.182.207.288.1.22.135.465.1.705a.965.965 0 0 1-.145.343Zm-3.845 7.077a38.398 38.398 0 0 1-1.806-1.417l1.453-1.805a.686.686 0 0 0-.117-.957.677.677 0 0 0-.948.117l-1.417 1.805c-.47-.424-.966-.902-1.463-1.372-.496-.47-.902-.993-1.372-1.462l1.806-1.418a.678.678 0 1 0-.84-1.065l-1.805 1.463a38.426 38.426 0 0 1-1.418-1.806l4.514-2.456 5.913 5.914-2.5 4.46ZM23.76 4.124 14.03 13.8l-1.589-1.589 9.696-9.696a1.138 1.138 0 0 1 1.837.364 1.11 1.11 0 0 1-.248 1.225l.036.018Z"
        />
      </g>
      <defs>
        <clipPath id="eraseIcon">
          <path fill="#fff" d="M0 .242h26v26H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
